import React from "react";
import { CustomDialog } from "../../../../Components";
import { useTranslate } from "../../../../Hooks";

import useStyles from "./styles";

import { TrashOne } from "../../../../assets/icons";

function DiscardDialog({ isOpen, onClose, onDiscardAction }) {
  const styles = useStyles();
  const { translate } = useTranslate("AgentCommissionView");

  return (
    <CustomDialog
      paperClassName={styles.dialogWrapper}
      open={isOpen}
      onClose={() => {
        onClose(false);
      }}
      onConfirm={() => {
        onDiscardAction();
        onClose(true);
      }}
      headingIcon={
        <div className={styles.modalIcon}>
          <TrashOne width="20" height="20" fill={"#D92D20"} />
        </div>
      }
      title={translate("discard-changes-modal-title")}
      subtitle={translate("discard-changes-modal-content")}
      cancelText={translate("cancel")}
      confirmText={translate("discard")}
      hideActionsBorder
    />
  );
}

export default DiscardDialog;
